// extracted by mini-css-extract-plugin
module.exports = {"root":"_23cwA","card":"_2c7Nc","gridView":"_3WU_T","listView":"_2p-ZO","sidebar":"_2jo8F"};